module.exports = __webpack_public_path__ + "img/ASTRA.ac93d193.png";